import { createSlice } from "@reduxjs/toolkit";

export const jobfairSlice = createSlice({
  name: "jobfair",
  initialState: {
    list: [],
  },
  reducers: {
    setJobfair: (state, action) => {
      console.log("setJobfair", action.payload);
      state.list = action.payload.list;
    },
  },
});

export const { setJobfair } = jobfairSlice.actions;

export default jobfairSlice.reducer;
